import {useEffect, useRef} from 'react'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {useCustomerType} from '@salesforce/commerce-sdk-react'
import {useParams} from 'react-router-dom'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const useGoogleTagManager = (pathName) => {
    const {isRegistered} = useCustomerType()
    const {data: customer} = useCurrentCustomer()
    const prevPageTypeRef = useRef()
    const customerID =
        (typeof window !== 'undefined' ? localStorage.getItem('customer_id_Cavenders') : '') || ''
    const {contentID} = useParams()
    const {app: appConfig} = getConfig()

    useEffect(() => {
        if (!customer || prevPageTypeRef.current === pathName) return
        // Ensure the effect runs only when customer data is fully loaded
        if (isRegistered && !customer.email) return
        prevPageTypeRef.current = pathName // updating ref to track last used pageType
        let pageType = 'content'

        if (pathName === '/') {
            pageType = 'home'
        } else if (pathName.includes('/cart')) {
            pageType = 'cart'
        } else if (pathName.includes('/account')) {
            pageType = 'account'
        }
        if (contentID) {
            pageType = 'blog'
        }
        const dataLayer = window.dataLayer || []
        if (pageType) {
            if (pageType !== 'blog') {
                // Add check related to AdWords enabled
                let ecomm_pagetype = pageType
                if (pageType === 'content') {
                    ecomm_pagetype = 'other'
                }
                dataLayer.push({
                    google_tag_params: {
                        ecomm_pagetype: ecomm_pagetype
                    }
                })
            }

            dataLayer.push({
                email: isRegistered ? customer?.email?.toLowerCase() || '' : '',
                'page-type': pageType,
                session_id: customerID
            })
        }

        dataLayer.push({
            event_id: `${customerID}_${new Date().getTime()}`
        })

        const phoneNumber = customer.phoneMobile || customer.phoneHome
        const dataLayerObject = {
            registered: isRegistered ? 'true' : 'false',
            account_phone_number: phoneNumber ? phoneNumber.replace(/\D/g, '') : undefined
        }

        if (isRegistered) {
            dataLayerObject.userId = customer.customerId
            dataLayerObject.email = customer.email?.toLowerCase()
            dataLayerObject.sha256 = customer.hashedLogin
            dataLayerObject.first_name = customer.firstName?.toLowerCase()
            dataLayerObject.last_name = customer.lastName?.toLowerCase()
        }

        dataLayer.push(dataLayerObject)
        dataLayer.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        })
        window.dataLayer = dataLayer
        const gtmScript = document.createElement('script')
        gtmScript.async = true
        gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${appConfig.gtmData?.containerID}`
        document.head.appendChild(gtmScript)
        // hardcoding googleAdditionalHeaderTags for now which was comming from sitepreference for sitegenisis
        const gtagScript = document.createElement('script')
        gtagScript.async = true
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=DC-10957361'
        document.head.appendChild(gtagScript)
        const gtag = (...args) => dataLayer.push(args)
        gtag('js', new Date())
        gtag('config', 'DC-10957361')

        return () => {
            document.head.removeChild(gtmScript)
            document.head.removeChild(gtagScript)
        }
    }, [isRegistered, customer.email, pathName])
}

export default useGoogleTagManager
